import { render, staticRenderFns } from "./CreateMeasure.vue?vue&type=template&id=37d53e66&"
import script from "./CreateMeasure.vue?vue&type=script&lang=js&"
export * from "./CreateMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports